// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__CoiMY","item":"List_item__sMMS_","scrollable":"List_scrollable__9NWEY"};